/**
 * 模組頁面代碼: 1210-UI
 * 模組說明: 案件詳細資料頁面
 * @module CaseApplyContainer
 */

// ----- import from local libraries -----
import {React} from '../../components/BaseComponent';

// ----- import from local components -----
import {useState} from 'react';
import {useSelector} from 'react-redux';
import Footer from '../../features/main-frame/components/Footer';
import Header from '../../features/main-frame/components/Header';
import Sidebar from '../../features/main-frame/components/Sidebar';
import CaseApplyPage from './components/CaseApplyPage';
import CoordinatesModal from './components/CoordinatesModal';

// ----- constants and enums -----

const CaseApplyContainer = (props) => {
  const userPermissions =
    useSelector((state) => JSON.parse(state.access.userPermissions));

  const [isOpen, setIsOpen] = useState(false);
  // 初始化只有簡短的客戶資料，此狀態紀錄詳細的單一用戶資料
  const [selectedCustomerData, setSelectedCustomerData] = useState(null);

  const onOpenChange = (isOpenStatus)=>setIsOpen(isOpenStatus);

  return (
    <>
      <div className="m__wrap">
        <Header />
        <div className="m__contents">
          <Sidebar />
          <CaseApplyPage
            {...props}
            userPermissions={userPermissions}
            setSelectedCustomerData={(data) => setSelectedCustomerData(data)}
            onOpenChange={onOpenChange}
          />
        </div>
        <Footer />
        <CoordinatesModal
          isOpen={isOpen}
          onOpenChange ={onOpenChange}
          selectedCustomerData={selectedCustomerData}
        />
      </div>
    </>
  );
};

export default CaseApplyContainer;
